export default {
	ITEMCELL: 'itemCell',
	FOLDERCELL: 'folderCell',
	// SIDENAVSECTION: 'sideNavSection',
}



// WEBPACK FOOTER //
// ./src/components/DnDKit/ItemTypes.js